export * from '@primeuix/themes/lara/confirmdialog';
export { default } from '@primeuix/themes/lara/confirmdialog';
